import { CONFIRM_DIALOG_ON_BUTTON_CLICK } from './constants'

export function onButtonClick(type, id = null) {
    return {
        type: CONFIRM_DIALOG_ON_BUTTON_CLICK(type, id),
        data: {
            type,
            id,
        },
    }
}
